<div *ngIf="attendees?.length" (click)="expandAttendees()" [ngClass]="expandEnable ? 'expandable' : ''"
     class="attendee-detail">
    <span class="attendee-number">{{attendees.length}} khách</span>
    <i *ngIf="expandEnable" class="fa fa-angle-{{expanded ? 'up' : 'down'}}" style="padding-left: 10px"></i>
    <div class="attendee-desc">{{stateText}}</div>
</div>
<div [ngClass]="{'hide': !expanded}">
    <div class="attendee-item" *ngFor="let attendee of attendees">
        <div>
            <img *ngIf="attendee.username; else aliasAvatar"
                 class="attendee-avatar"
                 userAvatar [usercode]="attendee.username">
            <ng-template #aliasAvatar>
                <i class="attendee-avatar fa fa-question"></i>
            </ng-template>
        </div>
        <i *ngIf="attendee.state" [title]="attendee._stateText" [ngClass]="getStateIcon(attendee)"></i>
        <div class="attendee-content">
            <b>{{attendee.fullname || attendee.alias}} </b>
            <span> {{attendee.notes}}</span>
        </div>
        <div *ngIf="editable">
            <i class="attendee-remove fa fa-times" (click)="removeAttendee(attendee)"></i>
        </div>
    </div>
</div>